module.exports = typeof window == 'object';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/internals/engine-is-browser.js
// module id = 383
// module chunks = 0